import { useEffect, useRef } from "react";

const EVENT = "tadpole:meetings-changed";

/**
 * Meetings were changed somewhere that doesn't reload the calendar itself
 * (attendance, approval and rates, the bell's meeting window and requests).
 * The calendar drops what it loaded, so its next look loads afresh.
 */
export function announceMeetingsChanged() {
  window.dispatchEvent(new Event(EVENT));
}

/** Calls onChanged each time meetings are announced as changed. */
export function useMeetingsChanged(onChanged: () => void) {
  const latest = useRef(onChanged);
  latest.current = onChanged;
  useEffect(() => {
    const listener = () => latest.current();
    window.addEventListener(EVENT, listener);
    return () => window.removeEventListener(EVENT, listener);
  }, []);
}
